export enum AppointmentStatus {
  Cancelled = 'cancelled',
  CareTeamSentMessage = 'careTeamSentMessage',
  Completed = 'completed',
  Missed = 'Appointment • Missed'
}

export enum PlanCodesProps {
  AnnualMembership = 'lifemd-annual-membership',
  Appointment = 'appointment-30',
  ConciergeMembership = 'concierge-care',
  // Components
  InitialAppointment = 'initial-appointment',
  LifeMDMembership = 'membership',
  LifeMDPlus = 'lifemd-plus',
  LimitedAccess = 'limited-access',
  MensHealthMembership = 'mens-health',
  // New plans
  TotalCareMembership = 'total-care',
  // Old plans
  UnlimitedMembership = 'unlimited-membership',
  // --
  UrgentCare = 'urgent-care',
  WeightManagementMembership = 'weight-management',
  WomenHealthMembership = 'women-health'
}

export const ProgramCodeTypes = {
  TripleTherapy: 'triple-therapy-weight-management-medication-included'
} as const;
